import { render, staticRenderFns } from "./StepUpload.vue?vue&type=template&id=23384fe9&scoped=true&lang=pug"
import script from "./StepUpload.vue?vue&type=script&lang=js"
export * from "./StepUpload.vue?vue&type=script&lang=js"
import style0 from "./StepUpload.vue?vue&type=style&index=0&id=23384fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23384fe9",
  null
  
)

export default component.exports